import { dateFunc } from "@/components/Functions/dateFunc";
import "./attributeHistory.scss";
import { useTranslation } from "react-i18next";
export const useColumnHistoryDefs = (timeZone: string) => {
  const { t } = useTranslation();
  return [
    {
      cellRenderer: "attributeName",
      type: "attributeName",
      field: "attributeName",
      headerName: t(
        "pages.creditors.creditorAttributeTab.tableColumnsDetails.attributeName"
      ),
      minWidth: 150,
      flex: 1,
      sortable: true,
      unSortIcon: true,
      autoHeight: true,
      wrapText: true,
    },
    {
      field: "createdDate",
      type: "createdDate",
      sortable: true,
      unSortIcon: true,
      headerName: t(
        "pages.creditors.creditorAttributeTab.tableColumnsDetails.updatedOn"
      ),
      minWidth: 150,
      flex: 1,
      cellRendererParams: {
        timeZoneName: timeZone,
      },

      cellRenderer: function (params: any) {
        return (
          dateFunc(params.data.createdDate).formattedDateTime +
          " " +
          params.timeZoneName
        );
      },
    },
    {
      field: "createdBy",
      type: "createdBy",
      headerName: t(
        "pages.creditors.creditorAttributeTab.tableColumnsDetails.updatedBy"
      ),
      minWidth: 150,
      flex: 1,
      sortable: true,
      unSortIcon: true,
    },

    {
      field: "oldValue",
      type: "oldValue",
      headerName: t(
        "pages.creditors.creditorAttributeTab.tableColumnsDetails.oldValue"
      ),
      minWidth: 150,
      flex: 1,
      sortable: true,
      unSortIcon: true,
      cellRenderer: function (params: any) {
        return (
          <div style={{ overflowWrap: "anywhere" }} className="text-wrap   ">
            {params.data.oldValue || "-"}
          </div>
        );
      },
      wrapText: true,
      autoHeight: true,
      cellStyle: {
        wordWrap: "break-all",
      },
    },
    {
      field: "newValue",
      sortable: true,
      unSortIcon: true,
      type: "newValue",
      headerName: t(
        "pages.creditors.creditorAttributeTab.tableColumnsDetails.newValue"
      ),
      wrapText: true,
      autoHeight: true,

      minWidth: 150,
      flex: 1,
      // headerClass: "stepHeaderClass",
      // cellClass: "align-right",
      cellRenderer: function (params: any) {
        return (
          <div
            style={{ overflowWrap: "anywhere" }}
            className="text-wrap text-break"
          >
            {params.data.newValue || "-"}
          </div>
        );
      },
    },
  ];
};

export const columnHistoryDefs = [
  {
    cellRenderer: "attributeName",
    field: "attributeName",
    headerName: "Attibute Name",
    width: 150,
    sortable: true,
    unSortIcon: true,
  },
  {
    field: "createdDate",
    headerName: "Updated On",
    flex: 1,
    width: 150,

    cellRenderer: function (params: any) {
      return dateFunc(params.data.createdDate).formattedDateTime;
    },
  },
  {
    field: "createdBy",
    headerName: "Updated By",
    flex: 1,
    width: 150,
  },

  {
    field: "oldValue",
    headerName: "Old Value",
    flex: 1,
    width: 350,
    cellRenderer: function (params: any) {
      return <div className="text-wrap ">{params.data.oldValue || "-"}</div>;
    },
  },
  {
    field: "newValue",
    headerName: "New Value",
    flex: 1,
    width: 350,
    cellRenderer: function (params: any) {
      return <div className="text-wrap ">{params.data.newValue || "-"}</div>;
    },
  },
];
